import { combineReducers } from 'redux'

import {
  CLEAR,
  IMPORT_PROJECT_START,
  IMPORT_PROJECT_SUCCESS,
  IMPORT_PROJECT_ERROR,
  SET_IMPORT_DIALOG_ACTIVE,
  SET_IMPORT_DIALOG_CONFIRM,
  SET_IMPORT_DIALOG_DONE,
  SET_IMPORT_DIALOG_ERROR,
  SET_PROJECT_LIST,
  SET_PROJECT_SELECTED
} from './constants'
import {
  createReducer,
} from 'helpers/ReducerUtil'

const dialogPage = createReducer(0, {
  [CLEAR]: () => 0,
  [SET_IMPORT_DIALOG_ACTIVE]: () => 1,
  [SET_IMPORT_DIALOG_CONFIRM]: () => 2,
  [IMPORT_PROJECT_START]: () => 3,
  [SET_IMPORT_DIALOG_DONE]: () => 4,
  [SET_IMPORT_DIALOG_ERROR]: () => 5,
})

const projectList = createReducer([], {
  [CLEAR]: () => [],
  [SET_PROJECT_LIST]: (_, { projectList }) => Object.values(projectList)
})

const projectSelected = createReducer(null, {
  [CLEAR]: () => null,
  [SET_PROJECT_SELECTED]: (_, { project }) => project
})

const projectImport = combineReducers({
  dialogPage,
  projectList,
  projectSelected
})

export default combineReducers({
  projectImport
})
